class CalloutGrid extends elementorModules.frontend.handlers.Base {
  protected swiperInstance: any = null;

  constructor($element: JQuery, args: any) {
    console.log("CalloutGrid run");
    super($element, args);
  }

  getDefaultSettings() {
    return {
      selectors: {
        swiperContainer: ".swiper",
      },
    };
  }
  getDefaultElements() {
    const selectors = this.getSettings("selectors");
    return {
      $swiperContainer: this.$element.find(selectors.swiperContainer),
    };
  }
  bindEvents() {}
}

/**
 * Register JS Handler for the Test Widget
 *
 * When Elementor frontend was initiated, and the widget is ready, register the widet
 * JS handler.
 */
window.addEventListener("elementor/frontend/init", () => {
  elementorFrontend.elementsHandler.attachHandler(
    "gravitas_calloutGrid",
    CalloutGrid
  );
});
